import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { Observable, Subject, of } from 'rxjs';
import { environment } from '../environments/environment';

declare var CURRENT_USER_ID: number;
declare var CURRENT_USER_LOGINID: string;
declare var CURRENT_USER_DISPLAYNAME: string;
declare var CURRENT_USER_EMAIL: string;
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loginSuccessSubject = new Subject<AuthenticationResult>();
  public loginSuccess$: Observable<AuthenticationResult> = this.loginSuccessSubject.asObservable();

  constructor(private msalService: MsalService) {
    // Listen for login success events
    //this.msalService.instance.enableAccountStorageEvents();
  }

  /** Whether MSAL auth is bypassed for local development */
  get isDevBypass(): boolean {
    return !environment.production && environment.devBypassAuth === true;
  }

  /**
   * Check if user is logged in
   */
  isLoggedIn(): boolean {
    if (this.isDevBypass) {
      return true;
    }
    var  isLoggedIn =  this.msalService.instance.getAllAccounts().length > 0;
     
    return isLoggedIn;
 }

  /**
   * Get the active account
   */
  getActiveAccount() {
    if (this.isDevBypass) {
      // Return a fake account-like object using index.html globals
      return {
        name: CURRENT_USER_DISPLAYNAME,
        username: CURRENT_USER_EMAIL,
        localAccountId: String(CURRENT_USER_ID),
        environment: 'dev-bypass',
        homeAccountId: String(CURRENT_USER_ID),
        tenantId: 'dev-bypass'
      } as any;
    }
    var userAccount =  this.msalService.instance.getActiveAccount();
    CURRENT_USER_DISPLAYNAME = userAccount?.name || '';
    CURRENT_USER_EMAIL = userAccount?.username || '';

    
    return userAccount;
  }

  /**
   * Get all accounts
   */
  getAllAccounts() {
    return this.msalService.instance.getAllAccounts();
  }

  /**
   * Login with popup
   */
  loginPopup() {
    if (this.isDevBypass) return of(null as any);
    return this.msalService.loginPopup();
  }

  /**
   * Login with redirect - no-op in dev bypass
   */
  loginRedirect() {
    if (this.isDevBypass) return;
    return this.msalService.loginRedirect();
  }

  /**
   * Logout with popup
   */
  logoutPopup() {
    if (this.isDevBypass) return of(null as any);
    return this.msalService.logoutPopup();
  }

  /**
   * Logout with redirect - no-op in dev bypass
   */
  logoutRedirect() {
    if (this.isDevBypass) return;
    return this.msalService.logoutRedirect();
  }

  /**
   * Get user display name
   */
  getUserDisplayName(): string {
    if (this.isDevBypass) return CURRENT_USER_DISPLAYNAME;
    const account = this.getActiveAccount();
    return account?.name || '';
  }

  /**
   * Get user email
   */
  getUserEmail(): string {
    if (this.isDevBypass) return CURRENT_USER_EMAIL;
    const account = this.getActiveAccount();
    return account?.username || '';
  }

  /**
   * Acquire token silently
   */
  acquireTokenSilent(scopes: string[]) {
    if (this.isDevBypass) return of({ accessToken: 'dev-bypass-token' } as any);
    const account = this.getActiveAccount();
    if (account) {
      return this.msalService.acquireTokenSilent({
        scopes: scopes,
        account: account
      });
    }
    throw new Error('No active account');
  }
}
